import { jsx as r } from "react/jsx-runtime";
import { FeaturedStoresList as n, FeaturedStoresListItem as i, FeaturedStoresLink as d } from "./styles.js";
import { useDropdownContext as m } from "../../contexts/Dropdown/context.js";
function l({
  stores: t
}) {
  const { closeDropdown: o } = m();
  return /* @__PURE__ */ r(n, { children: t.map((e) => /* @__PURE__ */ r(i, { onClick: o, children: /* @__PURE__ */ r(d, { url: e.link, children: e.name }) }, e.id)) });
}
export {
  l as FeaturedStoresMenuItem
};
